// Navigation
export const OPEN_NAVIGATION = 'open_navigation';
export const CLOSE_NAVIGATION = 'close_navigation';
export const TOGGLE_NAVIGATION = 'toggle_navigation';
